<!-- 栏目设置 -->
<template>
  <div class="">
    <div class="header">
      <div class="user"
           @click="$router.go(-1)">
        <Icon type="ios-arrow-back"
              size="22" />
      </div>
    </div>
    <!-- 简洁名片 -->
    <plain-card></plain-card>
    <!-- 栏目 -->
    <div class="item"
         v-for="(item, index) in columnSti"
         :key="index">
      <div class="title"
           v-if="item.flag === 1">{{ item.name }}</div>
      <div :class="item.description === '' ? 'noContent': 'content'"
           v-if="item.flag === 1">
        <p class="text"
           v-if="item.flag === 1">
          {{ item.description }}
        </p>
        <p v-if="item.estimatedReleaseTime"
           class="time">预计发表时间 {{ item.estimatedReleaseTime }}</p>
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import plainCard from "@/components/plain_card";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    plainCard,
  },
  data() {
    //这里存放数据
    return {
      columnSti: [],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    //栏目设置
    columnSetup() {
      var data = {
        periodicalId: this.$store.state.qikanId,
      };
      this.$apis.manage.columnSetup(data).then((res) => {
        this.columnSti = res.content.columnList;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() { },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.columnSetup();
  },
  beforeCreate() { }, //生命周期 - 创建之前
  beforeMount() { }, //生命周期 - 挂载之前
  beforeUpdate() { }, //生命周期 - 更新之前
  updated() { }, //生命周期 - 更新之后
  beforeDestroy() { }, //生命周期 - 销毁之前
  destroyed() { }, //生命周期 - 销毁完成
  activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
.noContent {
  background-color: #fff;
  height: 1px;
  font-size: 16px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
  line-height: 29px;
}
.content {
  background-color: #fff;
  padding: 20px 19px 20px 19px;
  font-size: 16px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  color: #333333;
  line-height: 29px;
}
.header {
  height: 52px;
  line-height: 52px;
  text-align: center;
  padding: 0 18px;
  display: flex;
  justify-content: flex-start;
  background-color: #fff;
  margin-bottom: 15px;
  .user {
    display: flex;
    // justify-content: space-around;
    align-items: center;
    width: 100px;
    img {
      width: 18px;
      height: 18px;
    }
  }
}
//@import url(); 引入公共css类
.item {
  .title {
    height: 55px;
    line-height: 55px;
    padding-left: 19px;
    font-size: 21px;
    font-family: Source Han Sans SC;
    font-weight: bold;
    color: #333333;
  }
  .content {
    background-color: #fff;
    padding: 20px 19px 20px 19px;
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #333333;
    line-height: 29px;
    .text {
      margin-bottom: 10px;
    }
    .time {
      color: #2150cb;
    }
  }
}
</style>
